.header {
    background: linear-gradient(90deg, #253c61 0%, #2b3b5c 25%, #353955 50%, #41374e 75%, #4b3649 100%);
}

.headerIcon {
    color: var(--mantine-color-gray-5);

    &:hover {
        color: white;
    }
}
